
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_d090a_9",
  "group-layout-wrapper": "awsui_group-layout-wrapper_o08jm_d090a_41",
  "action-slot": "awsui_action-slot_o08jm_d090a_45",
  "group-layout": "awsui_group-layout_o08jm_d090a_41",
  "group-layout-horizontal": "awsui_group-layout-horizontal_o08jm_d090a_55",
  "group-layout-vertical": "awsui_group-layout-vertical_o08jm_d090a_58",
  "controls": "awsui_controls_o08jm_d090a_62",
  "controls-horizontal": "awsui_controls-horizontal_o08jm_d090a_67",
  "controls-vertical": "awsui_controls-vertical_o08jm_d090a_73",
  "control": "awsui_control_o08jm_d090a_62",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_d090a_82",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_d090a_82",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_d090a_85",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_d090a_85",
  "control-validation": "awsui_control-validation_o08jm_d090a_88",
  "control-in-error": "awsui_control-in-error_o08jm_d090a_102",
  "control-in-warning": "awsui_control-in-warning_o08jm_d090a_105",
  "control-first-horizontal": "awsui_control-first-horizontal_o08jm_d090a_108",
  "control-only-horizontal": "awsui_control-only-horizontal_o08jm_d090a_108",
  "control-only-vertical": "awsui_control-only-vertical_o08jm_d090a_108",
  "control-first-vertical": "awsui_control-first-vertical_o08jm_d090a_112",
  "sensor": "awsui_sensor_o08jm_d090a_124",
  "ghost-anchor": "awsui_ghost-anchor_o08jm_d090a_136",
  "inline-label": "awsui_inline-label_o08jm_d090a_141",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_d090a_166",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_d090a_171",
  "ghost": "awsui_ghost_o08jm_d090a_136"
};
  